// extracted by mini-css-extract-plugin
export default {"link":"SocialMediaLink_link__91k0R"};